@if (brand == 'prixtel') {
  <app-vitrine-menu></app-vitrine-menu>
}
@if (brand == 'coriolis') {
  <app-vitrine-menu-coriolis></app-vitrine-menu-coriolis>
}
<div [id]="'wrapper-' + brand" class="wpx_wrap mt-4">
  <h1>Votre commande@if (brand == 'prixtel') {
    <span></span>
  }</h1>
</div>
<div [id]="'login-form-' + brand" class="form_container mt-4">
  <div class="wpx_wrap">
    <div class="card card-subscription my-5">
      @if (step != 3 && isValidToken !== false) {
        <div class="card-body">
          <p class="mb-4">
            Bonjour <span class="bold-text">{{customer.firstName}} {{customer.lastName}},</span>
            <br/><br/>
            Nous sommes ravis de vous compter bientôt parmi nos clients.<br/>
            Voici l'offre qui vous a été proposée:
          </p>
          @for (product of vadSubscription.products; track product; let index = $index) {
            <div class="mb-3">
              <div><strong>Forfait @if (vadSubscription.products.length > 1) {
                <span>{{ index + 1 }} </span>
              }:</strong> {{ product.offer_label.replace('u2019', "'").replace('u2018', "'") }} + Appels et SMS/MMS illimités</div>
              @if (brand == 'coriolis') {
                <div>
                  @if ([0, null, undefined, ''].indexOf(product.promo_duration_in_months) !== -1) {
                    <div>
                      <strong>Prix du forfait :</strong> {{ product.offer_amount.toString().replace('.00', '').replace('.', ',') }}€ TTC/mois
                    </div>
                  }
                  @if ([0, null, undefined, ''].indexOf(product.promo_duration_in_months) == -1) {
                    <div>
                      @if (product.promo_duration_in_months == 1) {
                        <span><strong>Prix du forfait :</strong> {{ (product.promo_offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC le 1er mois, puis {{ (product.offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC/mois</span>
                      }
                      @if (product.promo_duration_in_months > 1) {
                        <span><strong>Prix du forfait :</strong> {{ (product.promo_offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC/mois pendant {{ product.promo_duration_in_months }} mois, puis {{ (product.offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC/mois</span>
                      }
                    </div>
                  }
                </div>
              }
              @if (brand == 'prixtel') {
                <div>
                  <div>
                    <strong>Prix du forfait :</strong> Le prix mensuel varie en fonction de la consommation Internet :
                  </div>
                  @for (shunter of product.shunters_data; track shunter; let i = $index) {
                    <div>
                      <span>- {{ shunter }} Go pour {{ product.shunters_price[i].toString().replace('.', ',') }}€ TTC/mois</span>
                    </div>
                  }
                  @if ([0, null, undefined, ''].indexOf(product.promo_duration_in_months) == -1) {
                    <div>
                      @if (product.promo_duration_in_months == 1 && product.promo_offer_amount == 0) {
                        <span><strong>1er mois offert</strong></span>
                      }
                      @if (product.promo_offer_amount > 0) {
                        <span><strong>Prix du forfait :</strong>  {{ (product.promo_offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC/mois pendant {{ product.promo_duration_in_months }} mois, puis {{ (product.offer_amount).toString().replace('.00', '').replace('.', ',') }}€ TTC/mois</span>
                      }
                    </div>
                  }
                </div>
              }
              <div>
                <strong>Durée d'engagement :</strong> {{ [0, null, undefined, ''].indexOf(product.commitment_duration_in_months) !== -1 ? 'Sans engagement' : 'Engagement '+product.commitment_duration_in_months+' mois' }}
              </div>
              @if ([0, null, undefined, ''].indexOf(product.msisdn) == -1) {
                <div>
                  <strong>Numéro de téléphone :</strong> {{ product.msisdn }}
                </div>
              }
              @if ([0, null, undefined, ''].indexOf(product.port_date) == -1) {
                <div>
                  <strong>Date de portabilité :</strong> {{ formatDate(product.port_date) }}
                </div>
              }
              @if (product.device_label) {
                <div>
                  <strong>Smartphone :</strong> {{ product.device_label }}
                  <br/>
                  <strong>Prix :</strong> {{ product.device_amount.toString().replace('.00', '').replace('.', ',') }}€ TTC
                </div>
              }
            </div>
          }
          <div class="mb-3">
            <strong>À payer aujourd'hui :</strong>
            @if ([0, null, undefined, ''].indexOf(vadSubscription.totalDevices) == -1) {
              <br/>
            }
            @if ([0, null, undefined, ''].indexOf(vadSubscription.totalDevices) == -1) {
              <div class="ml-3">
                <strong>Téléphone(s) :</strong> {{ vadSubscription.totalDevices.toString().replace('.00', '').replace('.', ',') }}€ TTC
              </div>
            }
            <br/>
            <div class="ml-3">
              <strong>Frais d'activation :</strong> {{ vadSubscription.products.length == 1 ? '1€ TTC' :  '1€ TTC x ' + vadSubscription.products.length }}
            </div>
          </div>
          @if (form && step == 1) {
            <form class="form mb-3" [formGroup]="form" (submit)="saveIban()">
              Pour finaliser votre commande, veuillez saisir votre IBAN ci-dessous afin que nous puissions mettre en place le prélèvement automatique, puis régler votre commande à l'étape suivante :
              <br/><br/>
              <ul>
                <li>
                  <label class="bold-label-text">IBAN*</label>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="Entrez votre iBAN" formControlName="iban" required>
                    @if (formSubmitted && form.controls.iban.errors) {
                      <p class="error-message">{{ getError('iban') }}</p>
                    }
                  </div>
                </li>
                <li>
                  <label class="bold-label-text">BIC*</label>
                  <div class="form-group">
                    <input type="text" class="form-control" placeholder="BIC" formControlName="bic" required>
                    @if (formSubmitted && form.controls.bic.errors) {
                      <p class="error-message">{{ getError('bic') }}</p>
                    }
                  </div>
                </li>
              </ul>
              @if (errorMessage) {
                <div class="error-message text-center mb-3">{{ errorMessage }}</div>
              }
              <div class="checkbox">
                <input type="checkbox" name="acceptSepa" id="acceptSepa" (click)="setSepa($event)"/>
                <label for="acceptSepa" class="w-auto">En cochant cette case, j'accepte la génération d'un mandat SEPA.</label>
                <br/>
              </div>
              <div class="checkbox">
                <input type="checkbox" name="noEmail" id="recapContract" (click)="setRecapContract($event)"/>
                <label for="recapContract" class="w-auto">En cochant cette case, je reconnais avoir pris connaissance et accepter les documents suivants, applicables au service souscrit:
                <br/>
                  @for (product of products; track product) {
                    <div>
                      @if (product.recap_url) {
                        <a class="bold-text" href="{{ product.recap_url }}" target="_blank">Le Récapitulatif Contractuel {{ product.offer_label.replace('u2019', "'").replace('u2018', "'") }}</a>
                      }
                      <br/>
                      @if (product.guide_url) {
                        <a class="bold-text" href="{{ product.guide_url }}" target="_blank">Le Guide Tarifaire {{ product.offer_label.replace('u2019', "'").replace('u2018', "'") }}</a>
                      }
                    </div>
                  }
                  @if (brand == 'coriolis') {
                    <div>
                      <a class="bold-text" [href]="cgvUrl" target="_blank">Les Conditions Générales de vente à distance</a>
                      <br/>
                      <a class="bold-text" [href]="cgaUrl" target="_blank">Les Conditions Générales d'Abonnement</a>
                      <br/><br/>
                    </div>
                  }
                  @if (brand == 'prixtel') {
                    <div>
                      <a class="bold-text" [href]="cgvUrl" target="_blank">Les Conditions Générales de vente et d'abonnement</a>
                      <br/><br/>
                    </div>
                  }
                  Je reconnais avoir été informé qu'en application de l’article L221-18 et suivants du code de la consommation, je dispose d’un délai de 14 jours pour exercer mon droit de rétractation à compter de la livraison de ma carte SIM.
                </label>
              </div>
              <div class="checkbox">
                <input type="checkbox" name="noEmail" id="retractation" (click)="setRetractation($event)"/>
                <label for="retractation" class="w-auto">
                  Je souhaite utiliser le Service pendant la durée de la période de rétractation sans pour
                  autant renoncer à mon droit de rétractation. Je reconnais avoir été informé qu’en cas
                  d’utilisation du Service avant l’expiration du délai légal de 14 jours, je serai redevable
                  de l’abonnement prorata temporis, des communications et/ou services hors forfait
                  correspondant à l’utilisation du Service jusqu’à ma décision de me rétracter et/ou de la
                dépréciation du terminal dans les conditions prévues à l'article précité.</label>
              </div>
              <div class="cta_container">
                @if (retractation && recapContract && acceptSepa) {
                  <button type="submit" class="cta_btn level_2 column">Valider<span></span></button>
                }
              </div>
            </form>
          }
          @if (step == 2) {
            <div [id]="'app-style-' + brand">
              <div class="text-center">
                <strong>Montant à payer: {{ paymentDetailsInterface.amount }}€ TTC</strong>
              </div>
              <app-payment-form [paymentDetailsInterface]="paymentDetailsInterface"></app-payment-form>
            </div>
          }
        </div>
      }
      @if (step == 3 && isValidToken !== false) {
        <div class="card-body text-center">
          <p class="mb-2">
            Votre commande a bien été enregistrée.<br/><br/>
            Dès qu’elle aura été validée, vous pourrez suivre son traitement dans votre Espace client.
            <br/><br/>
            <strong class="bold-text w-100">Merci pour votre confiance et à bientôt !</strong>
          </p>
        </div>
      }
      @if (isValidToken == false) {
        <div class="card-body text-center">
          <p class="mb-2">
            Votre lien de souscription est invalide ou il est expiré.
          </p>
        </div>
      }
    </div>
  </div>
</div>
